import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionLabelProps {
    index: string
    children: ReactNode
    className?: string
}

// Repère de fiche technique : numéro de section, filet, intitulé.
export const SectionLabel: FC<SectionLabelProps> = ({ index, children, className }): ReactNode => {
    return (
        <p className={cn('label-mono flex items-center gap-3 text-muted-foreground', className)}>
            <span className='text-signal-text'>
                {index}
            </span>

            <span aria-hidden='true' className='h-px w-8 bg-current opacity-50' />

            <span>
                {children}
            </span>
        </p>
    )
}
